module.exports = __webpack_public_path__ + "img/plus_bgs.663fa5fe.jpg";